var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgGroup(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 23,
    height: 15,
    viewBox: "0 0 23 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10.028 3.73877C10.028 5.39877 8.69338 6.73877 7.02764 6.73877C5.3619 6.73877 4.01726 5.39877 4.01726 3.73877C4.01726 2.07877 5.3619 0.73877 7.02764 0.73877C8.69338 0.73877 10.028 2.07877 10.028 3.73877ZM18.0557 3.73877C18.0557 5.39877 16.7211 6.73877 15.0553 6.73877C13.3896 6.73877 12.0449 5.39877 12.0449 3.73877C12.0449 2.07877 13.3896 0.73877 15.0553 0.73877C16.7211 0.73877 18.0557 2.07877 18.0557 3.73877ZM7.02764 8.73877C4.68958 8.73877 0.00341797 9.90877 0.00341797 12.2388V13.7388C0.00341797 14.2888 0.454975 14.7388 1.00688 14.7388H13.0484C13.6003 14.7388 14.0519 14.2888 14.0519 13.7388V12.2388C14.0519 9.90877 9.3657 8.73877 7.02764 8.73877ZM14.082 8.78877C14.4332 8.75877 14.7643 8.73877 15.0553 8.73877C17.3934 8.73877 22.0795 9.90877 22.0795 12.2388V13.7388C22.0795 14.2888 21.628 14.7388 21.0761 14.7388H15.8782C15.9885 14.4288 16.0588 14.0888 16.0588 13.7388V12.2388C16.0588 10.7688 15.266 9.65877 14.1221 8.82877C14.1191 8.82574 14.116 8.8218 14.1127 8.81749C14.1051 8.80758 14.096 8.79574 14.082 8.78877Z",
    fill: "#808080"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgGroup);
export default __webpack_public_path__ + "static/media/Group.6543c8b039ed15f989df6509502da8e8.svg";
export { ForwardRef as ReactComponent };